import { classToClass } from 'class-transformer'

export default function <T> (object: T): T {
  return classToClass(object, { ignoreDecorators: true })
}
